module.exports = __webpack_public_path__ + "static/img/btc.ca29152.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gif/btc.gif
// module id = t7sh
// module chunks = 56